import { render, staticRenderFns } from "./PicAddOrEdit.vue?vue&type=template&id=caa3be5e&scoped=true&"
import script from "./PicAddOrEdit.vue?vue&type=script&lang=js&"
export * from "./PicAddOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./PicAddOrEdit.vue?vue&type=style&index=0&id=caa3be5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa3be5e",
  null
  
)

export default component.exports